import { getAuthEndpoints } from '@root/misc/authCallbacks'
import React, { useEffect, useState } from 'react'

const trueOrFalse = (val: boolean) => val ? '✅' : '❌';

let __setter: (msg: string) => void = () => {}

export const addDebugMessage = (msg: string) => __setter(msg)

const WebviewDebug: React.FC = () => {
  const [rerender, setRerender] = useState(0)
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    __setter = (msg) => setMessages((prev) => [msg, ...prev])
  }, [])

  useEffect(() => {
    const interval = window.setInterval(() => {
      setRerender((prev) => prev + 1)
    }, 300)

    return () => {
      window.clearInterval(interval)
    }
  }, [])

  return <div>
    <h3>debug</h3>
    <div>
      <span>isWebview</span>
      <span>{trueOrFalse(getAuthEndpoints()?.isWebview)}</span>
    </div>
    <div>
      <span>authenticated but not participating?</span>
      <span>{trueOrFalse(getAuthEndpoints()?.authenticatedButNotParticipating)}</span>
    </div>
    <div>
      <span>window.Tippspiel</span>
      <span>{trueOrFalse((window as any).Tippspiel)}</span>
    </div>
    <div>
      <span>window.webkit.messageHandlers.['Tippspiel']</span>
      <span>{trueOrFalse((window as any).webkit?.messageHandlers?.['Tippspiel'])}</span>
    </div>
    {messages.map((m, index) => <div key={index}>{m}</div>)}
  </div>
}

export default WebviewDebug
